import React, { Component } from 'react';
import OperatorsMixer from './fm/OperatorsMixer.js';
import FilterSection from './FilterSection.js';
import FMParameter from './FMParameter.js';
import OscInfo from './OscInfo.js';
import OscillatorsContinuedComponent from './OscillatorsContinuedComponent.js';
import RackComponent from "components/effects/rack/RackComponent.js";
import Colors from 'components/Colors.js';
import FMOperatorControl from './FMOperatorControl.js';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import FMGenetix from './FMGenetix.js';
import LFOComponent from 'components/lfo/LFOComponent.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import OscillatorsComponent from './OscillatorsComponent.js';
import Notes from 'midi/Notes.js';
import Dropdown from 'react-dropdown'
import EnvelopesComponent from './EnvelopesComponent.js';
import SynthMods from './SynthMods.js';
import '../../Instruments.scss';
import '../../Fm.scss';
import {AMP, OP_B1, OP_B2, OP_A, FILTER, PITCH, MODULATION} from 'constants/envelope-types.js';
import {ENVELOPE_OPTIONS} from './constants.js';

const colors = new Colors();

class MultiSynthComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showMods: false,
            showGenetix: false,
            selectedOscillator: 0,
        };

        this.onClickMods = this.onClickMods.bind(this);
        this.onClickGenetix = this.onClickGenetix.bind(this);
    }

    onChooseOscillator(number) {
        this.setState({selectedOscillator: number});
    }

    onClickGenetix() {
        this.setState({showGenetix: !this.state.showGenetix});
    }

    onClickMods() {
        this.setState({showMods: !this.state.showMods});
    }
    render() {
        let instrument = this.props.instrument;
        let color = colors.getColorForTrack(this.props.track);
        if (colors.getBrightness(color) > 180) {
            color = colors.brighten(color, 0.6);
        }

        let osc = instrument.oscillatorNodes[this.state.selectedOscillator];

        return (
            <div
              onClick={(e) => e.stopPropagation()}
              className="instrument multi-synth rack-synth">
              <ConditionedComponent condition={!this.state.showMods && !this.state.showGenetix}>
                <div className="inner">
                  <div className="instrument-section">
                    <RackComponent
                      track={this.props.track}
                      scrollContainer={this.props.scrollContainer}
                      setSelectedOscillator={(osc) => this.setState({
                          selectedOscillator: Math.max(0, instrument.oscillatorNodes.indexOf(osc))
                      })}
                      send={this.props.send}
                      sequencerEngine={this.props.sequencerEngine}
                      effect={this.props.instrument}/>
                    <div
                      className="fm-parameters">
                      <div className="osc-name">{osc.name}</div>
                      <FMParameter
                        parameter={osc.harmonicityParameter}
                        oscillator={osc}
                        name="Harmonicity"
                        className="harmonicity"
                      />
                      <FMParameter
                        parameter={osc.modulationIndexParameter}
                        oscillator={osc}
                        name="Modulation"
                        className="modulation"
                      />
                    </div>
                  </div>
                  <div>
                  <div className="sections">
                    <div className="instrument-section">
                      <OperatorsMixer
                        sequencerEngine={this.props.sequencerEngine}
                        instrument={instrument}/>
                      <FilterSection
                        automation={this.props.automation}
                        sequencerEngine={this.props.sequencerEngine}
                        instrument={instrument}
                      />
                 </div>
                  <div className="instrument-section envelopes">
                    <div className="instrument-subsection envelopes">
                      <EnvelopesComponent
                        automation={this.props.automation}
                        envelopeOptions={ENVELOPE_OPTIONS}
                        sequencerEngine={this.props.sequencerEngine}
                        instrument={instrument}/>
                    </div>
                    <div className="aux-parameters">
                      <OscillatorsContinuedComponent
                        instrument={instrument}
                        selectedOscillator={this.state.selectedOscillator}
                        sequencerEngine={this.props.sequencerEngine}
                      />
                      <div
                        onClick={this.onClickMods}
                        className="mods-button common-button small-button">
                        {this.state.showMods ? 'BACK' : 'MODS'}
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                </div>
              </ConditionedComponent>
              <ConditionedComponent condition={this.state.showMods}>
                <div className="clear-fix"/>
                <SynthMods instrument={instrument}/>
                <div
                  onClick={this.onClickMods}
                  className="mods-button common-button small-button">
                  {this.state.showMods ? 'BACK' : 'MODS'}
                </div>
              </ConditionedComponent>
            </div>);
    }
}

export default MultiSynthComponent;
